<template>
  <CDialog v-model="isOpen" class="dialog--small">
    <header class="dialog-header align-items-start">
      <div class="flex-fill pdgr">
        <h1 class="h4 mrgv0">
          {{ $t('planification.groups.delete.title') }}
        </h1>
        <h2 v-if="group && group.name" class="h5 text-alt mrgt-- mrgb0">
          {{ group.name }}
        </h2>
      </div>

      <Btn variant="icon" @click="isOpen = !isOpen">
        <Icon id="close" :scale="0.75" />
      </Btn>
    </header>

    <main class="dialog-body">
      {{ $t('planification.groups.delete.message') }}
    </main>

    <div class="dialog-footer">
      <ListInline align="center" size="small">
        <li>
          <Btn variant="outline" @click="isOpen = false">
            {{ $t('common.cancel') }}
          </Btn>
        </li>
        <li>
          <Btn variant="danger" @click="deleteGroup">
            <div class="flex">
              <Loader v-if="loading" size="small" negative />
              <template v-else>
                {{ $t('common.delete') }}
              </template>
            </div>
          </Btn>
        </li>
      </ListInline>
    </div>
  </CDialog>
</template>

<script>
import eventBus from '@/eventBus';

import Loader from '@/components/ui/Loader';

export default {
  components: {
    Loader,
  },

  data() {
    return {
      isOpen: false,
      loading: false,
      group: null,
    };
  },

  watch: {
    isOpen(isOpen) {
      if (!this.isOpen) {
        this.group = null;
      }
    },
  },

  mounted() {
    eventBus.$on('togglePlanificationGroupDelete', this.handleToggle);
  },

  beforeDestroy() {
    eventBus.$off('togglePlanificationGroupDelete', this.handleToggle);
  },

  methods: {
    handleToggle(group) {
      this.group = group;
      this.isOpen = !this.isOpen;
    },

    deleteGroup() {
      this.loading = true;
      this.$store
        .dispatch('planification/deleteGroup', this.group)
        .then(() => {
          this.$store.dispatch('directories/getDirectories');
          this.isOpen = false;
        })
        .catch(error => {
          this.$notify({
            type: 'error',
            title: this.$t('common.error'),
            text: error.message || error,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
